import React from 'react'
import './Banner.css'
import video from './tunnel_-_27438 (Original).mp4'
import logo from './logo.png'
import Button from '@mui/material/Button';
import logo1 from './biglogo.png'
import Form from './Form';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
function Banner() {
  return (
    <>
    <div className="Banner">
      <div className="vid">
        <video src={video} loop autoPlay muted>
        </video>
        {/* <h1>Heloo</h1> */}
      </div>
      <div className="small-logo">
        <img src={logo} alt="logo"></img>
      </div>
     <div className="main_banner">

      <div className="center-logo">
        <img src={logo1} alt="logo"></img>
      </div>
      <div className="butt">
      <Button variant="contained" color="secondary" style={{boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.9)'}} onClick={() => window.location.replace("/#form")}>
        Register Now!
      </Button>
      </div>
      <div className='fb'>
      <a href="https://www.facebook.com/Horizon-2K22-103739792289089/?ti=as">< FacebookOutlinedIcon fontSize="large"  style={{margin:'0px 30px',color:"#578fff"}}/></a>
     <a href="https://www.instagram.com/bcrechorizon2k22/?utm_medium=copy_link">
        <InstagramIcon fontSize="large" style={{margin:'0px 30px',color:"rgb(255,20,147)"}} /></a>
      </div>
     </div>
    </div>
    
    </>
  )
}

export default Banner